export default __webpack_public_path__ + "static/media/actividad-46.0935d73e.mp3";